import api, { LockAvailabilityOverride } from '@api';
import {
    replaceItemByKey, useConfirm, usePageMessage, useParams
} from '@tsp-ui/core/utils';
import { useGetCurrentAccount } from '@utils/hooks';
import { useContext } from 'react';
import { useNavigate } from 'react-router-dom';

import { LockAvailabilityCard } from './LockAvailabilityCard';
import { LockAvailabilityContext } from './LockAvailabilityPage';


interface LockOverrideAvailabilityCardProps {
    override: LockAvailabilityOverride;
}

export function LockOverrideAvailabilityCard({ override }: LockOverrideAvailabilityCardProps) {
    const {
        lockAvailabilityOverrideId, lockAvailabilityDate, isAvailable, lockStart, lockEnd, description
    } = override;

    const { lockAvailabilityOverrides, setLockAvailabilityOverrides } = useContext(LockAvailabilityContext);

    const confirm = useConfirm();
    const navigate = useNavigate();
    const pageMessage = usePageMessage();
    const { customerID } = useParams();
    const { id: clientID } = useGetCurrentAccount();

    return (
        <LockAvailabilityCard
            key={lockAvailabilityOverrideId}
            date={lockAvailabilityDate}
            isOverride
            isAvailable={isAvailable}
            lockStartUTC={lockStart}
            lockEndUTC={lockEnd}
            title={description}
            onEdit={() => navigate(`${lockAvailabilityOverrideId}/edit-override`)}
            onDelete={async () => {
                if (await confirm('Are you sure you want to delete this override?')) {
                    try {
                        await api.availability.deleteLockAvailabilityOverride(
                            clientID, lockAvailabilityOverrideId, customerID
                        );

                        setLockAvailabilityOverrides(lockAvailabilityOverrides.filter(
                            ({
                                lockAvailabilityOverrideId: id
                            }) => id !== lockAvailabilityOverrideId
                        ));

                        pageMessage.success('Override deleted');
                    } catch (error) {
                        pageMessage.handleApiError('An error occurred while deleting the override', error);
                    }
                }
            }}
            onToggle={async () => {
                try {
                    setLockAvailabilityOverrides(
                        replaceItemByKey<LockAvailabilityOverride>(
                            lockAvailabilityOverrides,
                            await api.availability.updateLockAvailabilityOverride(clientID, {
                                ...override,
                                isAvailable: !isAvailable
                            }, customerID),
                            'lockAvailabilityOverrideId'
                        )
                    );
                } catch (error) {
                    pageMessage.handleApiError('An error occurred while toggling availability override', error);
                }
            }}
        />
    );
}
